import { render } from "./vueVideoPlayer.vue?vue&type=template&id=9d5dea10"
import script from "./vueVideoPlayer.vue?vue&type=script&lang=js"
export * from "./vueVideoPlayer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__